module.exports = __webpack_public_path__ + "static/kaart.16225bd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/kaart.png
// module id = 570
// module chunks = 215195506969686